/**
 * WalkAndPunch API
 * This is the WalkAndPunch Service API.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PunchViewModelDataSourceResult } from '../model/punchViewModelDataSourceResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AdHocFixesService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param excelPath Absolute path of xlsx file. Example: C:\\Test\\Folder\\test.xlsx
     * @param projectId 
     * @param templateId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bulkUpdateReadingPunchCodeFromExcel(excelPath?: string, projectId?: number, templateId?: number, observe?: 'body', reportProgress?: boolean): Observable<PunchViewModelDataSourceResult>;
    public bulkUpdateReadingPunchCodeFromExcel(excelPath?: string, projectId?: number, templateId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PunchViewModelDataSourceResult>>;
    public bulkUpdateReadingPunchCodeFromExcel(excelPath?: string, projectId?: number, templateId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PunchViewModelDataSourceResult>>;
    public bulkUpdateReadingPunchCodeFromExcel(excelPath?: string, projectId?: number, templateId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (excelPath !== undefined && excelPath !== null) {
            queryParameters = queryParameters.set('excelPath', <any>excelPath);
        }
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (templateId !== undefined && templateId !== null) {
            queryParameters = queryParameters.set('templateId', <any>templateId);
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PunchViewModelDataSourceResult>('put',`${this.basePath}/v1/AdHocFixes/BulkUpdateReadingPunchCodeFromExcel`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param excelPath Absolute path of xlsx file. Example: C:\\Test\\Folder\\test.xlsx
     * @param filesPath Absolute path of attachment files. Example: C:\\Test\\Folder\\Files
     * @param projectId 
     * @param templateId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public termocandelariaPunchesReset(excelPath?: string, filesPath?: string, projectId?: number, templateId?: number, observe?: 'body', reportProgress?: boolean): Observable<PunchViewModelDataSourceResult>;
    public termocandelariaPunchesReset(excelPath?: string, filesPath?: string, projectId?: number, templateId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PunchViewModelDataSourceResult>>;
    public termocandelariaPunchesReset(excelPath?: string, filesPath?: string, projectId?: number, templateId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PunchViewModelDataSourceResult>>;
    public termocandelariaPunchesReset(excelPath?: string, filesPath?: string, projectId?: number, templateId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (excelPath !== undefined && excelPath !== null) {
            queryParameters = queryParameters.set('excelPath', <any>excelPath);
        }
        if (filesPath !== undefined && filesPath !== null) {
            queryParameters = queryParameters.set('filesPath', <any>filesPath);
        }
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (templateId !== undefined && templateId !== null) {
            queryParameters = queryParameters.set('templateId', <any>templateId);
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PunchViewModelDataSourceResult>('put',`${this.basePath}/v1/AdHocFixes/TermocandelariaPunchesReset`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
